import { stringify } from "query-string"

import { apiInstance } from "./api"

const endpoint = "/promotion"

export const getPromotions = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true, skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const getPromotion = async (promotionId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/${promotionId}`)

  return response.data
}

export const addPromotion = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}`, data)

  return response.data
}

export const editPromotion = async (promotionId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/${promotionId}`, data)

  return response.data
}

export const deletePromotion = async (promotionId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.delete(`${endpoint}/${promotionId}`)

  return response.data
}


export const getMyPackages = async (queries) => {
  const { dhFoods } = apiInstance()
  
  const query = stringify(queries, {
    skipEmptyString: true, skipNull: true
  })

  const response = await dhFoods.delete(`${endpoint}/package?${query}`)

  return response.data
}

export const getMyPromotions = async (queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true, skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/package?${query}`)

  return response.data
}